import { render } from "./klb-q8.vue?vue&type=template&id=be3396aa&scoped=true"
import script from "./klb-q8.vue?vue&type=script&lang=js"
export * from "./klb-q8.vue?vue&type=script&lang=js"

import "./klb-q8.vue?vue&type=style&index=0&id=be3396aa&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be3396aa"]])

export default __exports__